import useBrands from './useBrands';
import usePublic from './usePublic';

const useVehicleLogo = (brandName: string) => {
    if (!brandName) {
        return usePublic(`assets/vehicleLogos/blank.svg`);
    }
    const brands = useBrands();

    const brandKeys = Object.keys(brands);

    const index = brandKeys.findIndex(brandKey => brandKey.toLowerCase() === brandName.toLowerCase());
    const brandKey = brandKeys[index];

    const logoFileName = index !== -1 ? brands[brandKey] : 'others.svg';

    return usePublic(`assets/vehicleLogos/${logoFileName}`);
};

export default useVehicleLogo;
